import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { postRequestMall } from './request/request';
import { judgeClient } from '@/utils/utils';
import { UseGetCurrentGameConfigHooks } from '@/hooks/useGetCurrentGameConfigHooks';

// 所有商品列表
export const apiGoodsListAll = function (params) {
  return postRequestMall('/sku/listNew', params);
};

// 预检商品
export const apiGoodsCheckCpSkus = function (params) {
  return postRequestMall('/sku/checkCpSkus', params);
};

// 购物车下单
export const apiOrderCartPlace = function (params) {
  const {
    currentGameConfig
  } = UseGetCurrentGameConfigHooks();
  return postRequestMall('/order/placeCar', _objectSpread(_objectSpread({
    plat: judgeClient()
  }, params), {}, {
    returnUrl: process.env.VUE_APP_DOMAIN_URL + currentGameConfig.value.path
  }));
};

// 订阅商品
export const apiSubGoodsPlace = function (params) {
  return postRequestMall('/order/placeSubscribe', params, false, true);
};

// 获取是否授权
export const apiGetAuth = function (params) {
  return postRequestMall('/game/role/roleMandateStatus', params, false, true);
};

// 授权订阅
export const apiAuthSub = function (params) {
  return postRequestMall('/order/mandate', params, false, true);
};

// （免登录）确认角色信息
export const apiGameRoleConfirmRole = function (params) {
  return postRequestMall('/game/role/confirmRole', params);
};

// （免登录）通过orderToken得到订单列表
export const apiOrderListOrderToken = function (params) {
  return postRequestMall('/order/listOrderToken', params);
};

// 获取订单状态
export const apiGetOrderStatus = function (params) {
  return postRequestMall('/order/checkOrderStatus', params, false, false);
};

// 取消订阅
export const apiCancelSub = function (params) {
  return postRequestMall('/order/cancelSub', params, false, true);
};

// 使用兑换码
export const apiUseRedeem = function (params) {
  return postRequestMall('/redeem/useRedeem', params, false, false);
};

// 获取私域链接（国内）
export const apiOrderAttentionLink = function (params) {
  return postRequestMall('/order/attentionLink', params, false, false);
};

// 获取赠送活动（限时返利）
export const apiGetAwardList = function (params) {
  return postRequestMall('/game/awardList', params, false, false);
};